import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { FormData } from "../../state/Agencies/FormData";

const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.AGENCIES_FORM_UPDATED:
      return { ...state, ...action.data };
    case ActionType.AGENCIES_FORM_RESET:
      return new FormData();
    default:
      return state;
  }
};

export default updateFormData;